import { render, staticRenderFns } from "./vTipos_productos.vue?vue&type=template&id=2f044193&scoped=true"
import script from "./vTipos_productos.vue?vue&type=script&lang=js"
export * from "./vTipos_productos.vue?vue&type=script&lang=js"
import style0 from "./vTipos_productos.vue?vue&type=style&index=0&id=2f044193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f044193",
  null
  
)

export default component.exports